function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { useSelector } from 'react-redux';
import claimEmployeeRndApportionmentsService from '../../services/claim/claim_employee_rnd_apportionments.service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import ApportionmentsList from '../ApportionmentsList';
import independentRndContributionsService from '../../services/claim/independent_rnd_contributions.service';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export function IndependentRndContributionsRow(_ref) {
  let {
    sortedClaimProjectReports,
    index,
    claim,
    handleDelete,
    independentRndContributions,
    setIndependentRndContributions,
    refreshClaim,
    handleError,
    headerScrollPosition,
    isShowInvolvement
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const user = useSelector(state => state.auth.user);
  const claimEmployeeRndApportRef = useRef(null);
  const independentRndContribution = useMemo(() => {
    return _objectSpread({}, independentRndContributions[index]);
  }, [independentRndContributions, index]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (claimEmployeeRndApportRef.current) {
      claimEmployeeRndApportRef.current.scrollTo({
        left: headerScrollPosition
      });
    }
  }, [claimEmployeeRndApportRef, headerScrollPosition]);
  const updateIndependentRndContributions = useCallback(independentRndContribution => {
    const newIndependentRndContributions = [...independentRndContributions];
    newIndependentRndContributions[index] = _objectSpread({}, independentRndContribution);
    setIndependentRndContributions([...newIndependentRndContributions]);
  }, [independentRndContributions, index, setIndependentRndContributions]);
  const handleApportionmentChange = useErrorHandling(useCallback(async (independentRndContribution, apportionment) => {
    const oldApportionment = independentRndContribution.claim_employee_rnd_apportionments.find(a => a.claim_project_report_id === apportionment.claim_project_report_id);
    const index = independentRndContribution.claim_employee_rnd_apportionments.indexOf(oldApportionment);
    const newApportionments = [...independentRndContribution.claim_employee_rnd_apportionments];
    if (index === -1) {
      newApportionments.push(apportionment);
    } else {
      newApportionments[index] = _objectSpread({}, apportionment);
    }
    const updatedIndependentRndContribution = await independentRndContributionsService.get(independentRndContribution);
    updatedIndependentRndContribution.claim_employee_rnd_apportionments = newApportionments;
    updateIndependentRndContributions(updatedIndependentRndContribution);
  }, [updateIndependentRndContributions]));
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    independentRndContribution[event.target.name] = value;
    updateIndependentRndContributions(independentRndContribution);
  }, [updateIndependentRndContributions, independentRndContribution]);
  const saveChange = useCallback(() => {
    let method;
    if (independentRndContribution.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    independentRndContributionsService[method](independentRndContribution).then(updatedIndependentRndContribution => {
      setHasError(false);
      updateIndependentRndContributions(updatedIndependentRndContribution);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateIndependentRndContributions, independentRndContribution, dispatch, refreshClaim]);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "name",
    object: _objectSpread(_objectSpread({}, independentRndContribution), {}, {
      claim: _objectSpread(_objectSpread({}, claim), independentRndContribution.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "net_amount",
    object: _objectSpread(_objectSpread({}, independentRndContribution), {}, {
      claim: _objectSpread(_objectSpread({}, claim), independentRndContribution.claim)
    }),
    size: "sm",
    type: "text"
  })), claim.claim_group.project_methodology === 'project_basis' && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ApportionmentsList, {
    claim: claim,
    sortedClaimProjectReports: sortedClaimProjectReports,
    headerScrollPosition: headerScrollPosition,
    claimEmployeeRndApportRef: claimEmployeeRndApportRef,
    handleApportionmentChange: handleApportionmentChange,
    claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService,
    model: independentRndContribution,
    apportionmentable_type: "UkSection::IndependentRndContribution",
    isShowInvolvement: isShowInvolvement
  })), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, independentRndContribution), {}, {
      claim: _objectSpread(_objectSpread({}, claim), independentRndContribution.claim)
    }),
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "direct_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, independentRndContribution), {}, {
      claim: _objectSpread(_objectSpread({}, claim), independentRndContribution.claim)
    }),
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "indirect_rnd_apportionment",
    type: "text",
    size: "sm"
  }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: !hasPermissions() || claim.claim_group.project_methodology === 'project_basis',
    name: "rnd_apportionment",
    object: _objectSpread(_objectSpread({}, independentRndContribution), {}, {
      claim: _objectSpread(_objectSpread({}, claim), independentRndContribution.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    disabled: true || !hasPermissions(),
    name: "rnd_amount",
    object: _objectSpread(_objectSpread({}, independentRndContribution), {}, {
      claim: _objectSpread(_objectSpread({}, claim), independentRndContribution.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, hasPermissions() && /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    style: {
      height: '28px'
    },
    onClick: handleDelete
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-danger"
  }, "delete")))));
}